import { Attrs, MinzeElement } from 'minze'

export interface LvcPencilIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcPencilIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 28],
    ['data-height', 29],
  ]
  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.51 22.875c1.644-2.883 8.095-10.044 12.054-14.201a.5.5 0 0 0-.108-.777l-4.17-2.457a.49.49 0 0 0-.593.07c-1.635 1.615-3.659 4.222-5.397 6.27-2.455 2.894-4.71 6.352-6.183 8.174a.505.505 0 0 0-.113.318v3.325a.5.5 0 0 0 .63.482l3.568-.96a.51.51 0 0 0 .312-.244Z" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/>
      <path d="M16.98 10.36c-.51-.194-.961-.6-1.404-.898-.451-.305-.917-.59-1.368-.895" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/>
    </svg>
  `
  css = () => `
    
  `
}
